import { z } from 'zod';

export const commandSchema = z.object({
  action: z.enum(['start', 'stop', 'feedhold', 'estop', 'jog']),
  payload: z.any().optional(),
});

export type Command = z.infer<typeof commandSchema>;

export const dncUploadSchema = z.object({
  filename: z.string().min(1).max(255),
  sizeBytes: z.number().int().min(1),
  checksum: z.string().min(1), // SHA-256 or similar
});

export type DncUpload = z.infer<typeof dncUploadSchema>;
